import type { AsyncState } from '@essent/common';
import {
  createAsyncStateReducer,
  createInitialAsyncState,
} from '@essent/common';
import type { InsulationNewCustomerAddressCheckResponseV1 } from '@innogy/feh/models';
import {
  getInsulationAddressCheck,
  getInsulationAddressCheckClear,
  getInsulationAddressCheckError,
  getInsulationAddressCheckSuccess,
  postInsulationConfirmationActions,
} from '@innogy/feh/temporary-core-modules';
import type { Action, ActionReducerMap } from '@ngrx/store';
import { combineReducers } from '@ngrx/store';

export const insulationApiKey = 'insulationAPI';

export type GetInsulationNewCustomerAddressCheckState =
  AsyncState<InsulationNewCustomerAddressCheckResponseV1>;
export type PostInsulationNewCustomerConfirmationState = AsyncState<void>;
export interface InsulationAPIState {
  getInsulationNewCustomerAddressCheck: GetInsulationNewCustomerAddressCheckState;
  postInsulationNewCustomerConfirmation: PostInsulationNewCustomerConfirmationState;
}

export const initialInsulationAPIState: InsulationAPIState = {
  getInsulationNewCustomerAddressCheck: createInitialAsyncState(),
  postInsulationNewCustomerConfirmation: createInitialAsyncState(),
};

const _getInsulationNewCustomerAddressCheckReducer = createAsyncStateReducer(
  getInsulationAddressCheck,
  getInsulationAddressCheckSuccess,
  getInsulationAddressCheckError,
  getInsulationAddressCheckClear
);

const _postInsulationNewCustomerConfirmationReducer = createAsyncStateReducer(
  postInsulationConfirmationActions
);

const _reducers: ActionReducerMap<InsulationAPIState, Action> = {
  getInsulationNewCustomerAddressCheck:
    _getInsulationNewCustomerAddressCheckReducer,
  postInsulationNewCustomerConfirmation:
    _postInsulationNewCustomerConfirmationReducer,
};

const _combinedReducers = combineReducers(_reducers);
export const insulationAPIReducer = (
  state: InsulationAPIState = initialInsulationAPIState,
  action: Action
): InsulationAPIState => _combinedReducers(state, action);
